<div class="rs-panel-flex">
  <form [formGroup]="emailSubmitForm">
    <div class="rs-panel-flex-cell rs-bg-c2">
      <p>
        <strong>{{ 'password.recovery.method.email.title' | translate }}</strong>
      </p>
      <p class="rs-padding-bottom1">
        {{ 'password.recovery.method.email.active.description' | translate }}
      </p>

      <div class="rs-flex-row rs-flex-collapse rs-flex-middle" *ngIf="!showChangeEmailId">
        <div class="rs-flex-columns small-9">
          <p>
            <strong class="rs-word-break-all">{{ activeEmailId }}</strong>
          </p>
        </div>
        <div class="rs-flex-columns small-3">
          <p class="text-right">
            <button
              (click)="showChangeEmailId = !showChangeEmailId"
              class="rs-link-action rs-link-action-edit"
            >
              <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">{{
                'password.recovery.method.email.pending.edit' | translate
              }}</span
              ><span class="rs-action-link-icon"></span>
            </button>
          </p>
        </div>
      </div>
      <span *ngIf="showChangeEmailId">
        <mprd-email-submit
          (validEmailSubmit)="onValidEmailSubmit($event)"
          (emailSubmitCancel)="onEmailSubmitCancel()"
          *ngIf="showChangeEmailId"
        ></mprd-email-submit>
      </span>

      <mprd-email-errors
        [errors]="emailSubmitForm.get('emailId').errors"
        *ngIf="isEmailFormHasErrors"
      ></mprd-email-errors>
    </div>
  </form>
</div>
